import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import es from "./locales/es.json";
import de from "./locales/de.json";

// Language priority for the runtime (incl. the no-login embed):
//   1. ?lang= URL param  -- the EigenAdvisor embed passes the user's advisor language here, so the
//      WHOLE app surface (not just the browser-locale chrome) localizes to match the advisor UI.
//   2. localStorage "lang" -- a returning user's explicit switcher choice.
//   3. navigator.language -- browser default.
// Default stays EN when none resolve to a supported language (no regression).
function readLangParam(): string | null {
  try {
    const fromSearch = new URLSearchParams(window.location.search).get("lang");
    if (fromSearch) return fromSearch;
    // The embed often carries params in the hash route (/#/embed/...?lang=es); parse that too.
    const hash = window.location.hash || "";
    const qIndex = hash.indexOf("?");
    if (qIndex >= 0) {
      const fromHash = new URLSearchParams(hash.slice(qIndex + 1)).get("lang");
      if (fromHash) return fromHash;
    }
  } catch {
    /* non-browser / malformed URL -> ignore */
  }
  return null;
}

const param = readLangParam();
const saved = localStorage.getItem("lang");
const browser = (navigator.language || "en").slice(0, 2);
const initial = ((param || saved || browser) || "en").slice(0, 2) as "en" | "es" | "de";

// Persist an explicit ?lang= so a same-session reload (e.g. after embed auth redirect) keeps it.
if (param) {
  try {
    localStorage.setItem("lang", initial);
  } catch {
    /* storage blocked -> i18n still inits with `initial` below */
  }
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    de: { translation: de },
  },
  lng: ["en", "es", "de"].includes(initial) ? initial : "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
  },
});

export default i18n;
